import React, { useState } from 'react';
import { Box, Button, Typography, IconButton, Stack, CircularProgress } from '@mui/material';
import { Delete } from '@mui/icons-material';
import dummySVG from '../assets/svg/dummy.svg';
import { notify } from './notify';
import { fileUploadService, getFileUrl } from '../services/s3-service';
import BlurImg from './BlurImg';
import { compressImage } from '../utils/format';

function ImageUpload({ currentImage, onUpload, onRemove, btnName, boxTitle }) {
    const [loading, setLoading] = useState(false);

    async function handleFileUpload(e) {
        // const { name } = e.target
        setLoading(true)
        try {
            const compressedFile = await compressImage(e.target.files[0]);
            let fileKey = await fileUploadService(compressedFile);
            const imgUrl = await getFileUrl({ fileKey });
            onUpload({ fileKey, fileUrl: imgUrl })
        } catch (error) {
            console.log(error)
            onUpload({ fileKey: null, fileUrl: null })
            if (error === "apiError")
                notify("error", "Error in File Uploading...");
        }
        setLoading(false)
    }



    return (
        <Box >
            <Stack direction={"column"} marginTop={1}>
                <Box sx={{ borderRadius: 2, p: 1, border: 0.1, width: 230, height: 200, position: 'relative' }}>
                    <Typography color="rgba(0, 0, 0, 0.5)" >{boxTitle ?? "Preview"}</Typography>
                    {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={currentImage} alt="upload" style={{ width: 150, height: 150 }} />
                    </Box> */}
                    <Stack width={"100%"} alignItems={"center"}>
                        <Box sx={{
                            boxShadow: 4,
                            width: 150, height: 150, borderRadius: 4, mb: 1, mt: 0.5, display: 'flex', justifyContent: 'center',
                            alignItems: 'center', position: "relative", overflow: 'hidden', // Ensure content doesn't overflow the box
                        }}> {
                                loading ? <CircularProgress size={50} color={"primary"} /> :
                                    <>
                                        <BlurImg imgUrl={currentImage ? currentImage : dummySVG} alt={"Category"} />
                                        {currentImage && <IconButton sx={{ position: "absolute", top: -5, right: -5 }} onClick={onRemove}>
                                            <Box bgcolor={"white"} borderRadius={100} width={25} height={25}
                                                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                                <Delete color='error' sx={{ fontSize: 20 }} />
                                            </Box>
                                        </IconButton>}
                                    </>
                            }
                        </Box>
                    </Stack>


                </Box>
                <Stack direction={"column"} marginTop={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                            variant="contained"
                            component="label"
                            startIcon={<img src="https://cdn.builder.io/api/v1/image/assets/da8c6f98bd6344d284db2ab1ba0838d7/9fb22d18ba2f1c5df6c9c527aac33b33b398691b030a82574ab7c05da6ace17d?apiKey=da8c6f98bd6344d284db2ab1ba0838d7&" alt="upload" />}
                            size="small"
                            sx={{ bgcolor: 'rgba(53, 65, 236, 0.65)', color: 'rgba(255, 255, 255, 1)', fontSize: 11, ml: 1 }}
                        >{btnName ?? "Upload Photo"}
                            <input
                                name='imgFile'
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleFileUpload}
                                aria-label="Upload profile picture"
                            />
                        </Button>
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
                            (Maximum 7Mb)
                        </Typography>
                    </Box>
                    {/* <Box
                        variant="outlined"
                        sx={{ display: 'flex', alignItems: 'center', gap: 1, width: "85%", padding: '4px 12px', mt: 2, ml: 2, borderRadius: 4, border: 1, borderColor: "divider" }}>
                        <img src="https://cdn.builder.io/api/v1/image/assets/da8c6f98bd6344d284db2ab1ba0838d7/ba031c6acf7c623a4c35d7109734b5f745a315976b5b370bde64fe67296df77a?apiKey=da8c6f98bd6344d284db2ab1ba0838d7&" alt="file" style={{ width: 20 }} />
                        <Typography variant="caption" sx={{ fontSize: 11 }}>Adbjfhfhfdkfd.png</Typography>
                        <IconButton size="small" onClick={onRemove} aria-label="Remove file">
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box> */}
                </Stack>  </Stack>
        </Box>
    );
};
export default ImageUpload;